module.exports = __webpack_public_path__ + "static/img/animals1.d77237ff.png";